import { RootDispatch } from 'storage/store';

import {
  CHAT_BEFORE_LOGIN,
  CONTACT_DETAILS,
  CONTRACTS_DASHBOARD,
  CONTRACT_DETAILS,
  CONSENTS_AND_OBLIGATIONS,
  KISA_MIGRATION_LOGIN,
  CLIENT_SYNCHRONIZATION
} from './featureTogglesNames';
import { domainConfig } from './domainConfig';

const { isPl } = domainConfig;

const managingFeatureToggles = (
  featureToggleName: string,
  featureState: boolean,
  dispatch: RootDispatch
) => {
  switch (featureToggleName) {
    case KISA_MIGRATION_LOGIN: {
      if (featureState && isPl) {
        dispatch.application.enableKisaLoginPageVisibility();
      } else {
        dispatch.application.disableKisaLoginPageVisibility();
      }
      break;
    }
    case CHAT_BEFORE_LOGIN: {
      dispatch.application.enableChatBeforeLogin(featureState);
      break;
    }
    case CONTACT_DETAILS: {
      dispatch.application.storeContactDetailsFeatureToggle(featureState);
      break;
    }
    case CONTRACTS_DASHBOARD: {
      dispatch.application.storeContractDashboardFeatureToggle(featureState);
      break;
    }
    case CONTRACT_DETAILS: {
      dispatch.application.storeContractDetailsFeatureToggle(featureState);
      break;
    }
    case CONSENTS_AND_OBLIGATIONS: {
      dispatch.application.storeConsentsAndObligationsFeatureToggle(
        featureState
      );
      break;
    }
    case CLIENT_SYNCHRONIZATION: {
      dispatch.application.setClientSynchroToggle(featureState);
      break;
    }
    default:
      break;
  }
};

export default managingFeatureToggles;
